import { render, staticRenderFns } from "./AddGroupInstance.vue?vue&type=template&id=35d6324a&scoped=true"
import script from "./AddGroupInstance.vue?vue&type=script&lang=js"
export * from "./AddGroupInstance.vue?vue&type=script&lang=js"
import style0 from "./AddGroupInstance.vue?vue&type=style&index=0&id=35d6324a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d6324a",
  null
  
)

export default component.exports